import _ from 'lodash';

const initialState = {
    packageList: null,
    packageDetails: null,
};

export default function packages(state = initialState, action) {
    switch (action.type) {
        case 'SAVE_PACKAGE_LIST':
            return {
                ...state,
                packageList: action.data
            }
        case 'SAVE_CREATED_PACKAGE_DETAILS':
            return {
                ...state,
                packageDetails: action.data
            }
		case 'RESET_PACKAGE_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/packages.js